import React from "react";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from "./pages/main";
import Favourites from "./pages/favourites";
import Analytics from "./pages/analytics";
import UploadImage from "./UploadImage";
import PasswordGate from "./components/PasswordGate";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/favourites" element={<Favourites />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/upload" element={<PasswordGate><UploadImage /></PasswordGate>} />
      </Routes>
    </Router>
  );
}

export default App;
